import SocialSharing from "./SocialSharing";

export * from "./SocialSharing";

export default SocialSharing;
